import React from "react";
import { Icon, IconProps } from "@mui/material";


export const Icone = ({ icone, ...rest }) => {
  return <Icon {...rest}>{icone}</Icon>;
};

